import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { CMS_PASSWORD } from "@/lib/game-cms";

export const SITE_SETTING_DEFAULTS: Record<string, string> = {
  facebook_url: "https://www.facebook.com/usalotteryclub",
  instagram_url: "https://www.instagram.com/usalotteryclub",
};

const updateSchema = z.object({
  password: z.string(),
  settings: z.record(z.string(), z.string().trim().max(500)),
});

export const getSiteSettings = createServerFn({ method: "GET" }).handler(async () => {
  const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
  const { data, error } = await supabaseAdmin.from("site_settings").select("key, value");
  if (error) return { ...SITE_SETTING_DEFAULTS };
  const map: Record<string, string> = { ...SITE_SETTING_DEFAULTS };
  for (const row of data ?? []) map[row.key] = row.value;
  return map;
});

export const updateSiteSettings = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => updateSchema.parse(data))
  .handler(async ({ data }) => {
    if (data.password !== CMS_PASSWORD) throw new Error("Unauthorized");
    const rows = Object.entries(data.settings).map(([key, value]) => ({ key, value }));
    if (rows.length === 0) return { ok: true as const };
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { error } = await supabaseAdmin.from("site_settings").upsert(rows, { onConflict: "key" });
    if (error) throw new Error(error.message);
    return { ok: true as const };
  });